import { useMemo } from 'react';
import { DefaultTheme, useTheme } from 'styled-components';
import { ComponentSize } from '@mews-ui/theme';

/** use in class components with withTheme HOC */
export const getThemeValue = <T extends keyof ComponentSize, K extends ComponentSize[T]>(
    theme: DefaultTheme,
    component: T,
    customSize?: K | ((defaultSize: K) => K)
) => {
    const defaultSize = theme.settings.componentSize[component];

    if (!customSize) {
        return defaultSize as K;
    }
    if (typeof customSize === 'string') {
        return customSize ?? defaultSize;
    }
    if (customSize instanceof Function) {
        return customSize(defaultSize as K);
    }
    return defaultSize as K;
};

/** use in functional components */
export const useThemeValue = <T extends keyof ComponentSize, K extends ComponentSize[T]>(
    component: T,
    customSize?: K | ((defaultSize: K) => K)
): K => {
    const theme = useTheme();
    return useMemo(() => getThemeValue(theme, component, customSize), [theme, component, customSize]);
};
